export interface MultiSelectOption {
  value: number;
  name: string;
  sub?: string;
}

/**
 * Checkbox list over numeric ids. `selected` may contain ids that are not in
 * `options` (e.g. members whose agent row is gone) — they stay selected and the
 * caller renders them separately; this component never drops them.
 */
export function MultiSelect({
  options,
  selected,
  onChange,
  emptyLabel = 'Nothing to choose from.',
  disabled = false,
}: {
  options: MultiSelectOption[];
  selected: number[];
  onChange: (next: number[]) => void;
  emptyLabel?: string;
  disabled?: boolean;
}) {
  const toggle = (value: number, on: boolean) => {
    onChange(on ? [...selected, value] : selected.filter((v) => v !== value));
  };

  if (!options.length) {
    return <div className="mselect"><div className="mselect-empty">{emptyLabel}</div></div>;
  }

  return (
    <div className="mselect">
      {options.map((option) => (
        <label key={option.value} className="mselect-row">
          <input
            type="checkbox"
            checked={selected.includes(option.value)}
            disabled={disabled}
            onChange={(e) => toggle(option.value, e.target.checked)}
          />
          <span>
            <span className="mselect-name">{option.name}</span>
            {option.sub && <span className="mselect-sub"> · {option.sub}</span>}
          </span>
        </label>
      ))}
    </div>
  );
}
